module.exports = __webpack_public_path__ + "static/vertical-garden2-a0636e1e6a61fe8c9999cfab1e519b29.jpg";